module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class="similarToursSelect__tour-logo">\n    <img src="'+
((__t=(operatorLogo))==null?'':__t)+
'" alt="operator-logo">\n</div>\n<div class="similarToursSelect__tour-info">\n    <div class="similarToursSelect__tour-price">\n        '+
((__t=(priceWithOilTax.formatNumber()))==null?'':__t)+
' руб.\n        ';
 if(tour.get('hotelAvailable') === 1) { 
__p+='\n            <i class="icon-i16_check2 warranted-icon warranted-icon_small js-warranted-icon-similar"><span class="tooltipContent">Высокая вероятность подтверждения бронирования отеля</span></i>\n        ';
 } 
__p+='\n    </div>\n    <div class="similarToursSelect__tour-oiltax">\n        ';
 if(oilTaxIsAbsent) {
__p+='\n            узнать топл. сбор\n        ';
} else{
__p+='\n            вкл. топл сбор: '+
((__t=( oilTax.formatNumber() ))==null?'':__t)+
' руб.\n        ';
}
__p+='\n    </div>\n</div>';
}
return __p;
};
